import { ChangeEvent, FunctionComponent, useState } from 'react'
import styles from './textArea.module.scss'
import { TextareaAutosize } from '@mui/material'
import { t } from 'i18next'

interface TextAreaProps {
    id?: string
    name?: string
    className?: string
    value?: string
    placeholder?: string
    maxLength?: number
    minLength?: number
    minRows?: number
    maxRows?: number
    disabled?: boolean
    autoFocus?: boolean
    error?: boolean
    readOnly?: boolean
    required?: boolean
    parent?: boolean
    onChange?: (value: string) => void
    onBlur?: () => void
    maxCount?: number
    actionText?: { label: string; action: () => void }
}

const TextArea: FunctionComponent<TextAreaProps> = ({
    id,
    name,
    className,
    value = '',
    placeholder,
    disabled = false,
    autoFocus = false,
    required = false,
    readOnly = false,
    parent = false,
    minRows = 2,
    maxRows = 3,
    onChange,
    onBlur,
    maxLength,
    minLength,
    maxCount,
    actionText
}: TextAreaProps) => {
    const [count, setCount] = useState<number>(value.length)
    const [errorCount, setErrorCount] = useState<boolean>(false)

    function handleChange(e: ChangeEvent<HTMLTextAreaElement>): void {
        const val: string = e.target.value
        const truncatedVal: string = maxCount && val.length > maxCount ? val.slice(0, maxCount) : val
        setCount(truncatedVal.length)

        if (onChange) onChange(truncatedVal)

        setErrorCount(val.length > maxCount!)
    }

    return (
        <div className={styles.TextAreaContainer}>
            <TextareaAutosize
                id={id}
                name={name}
                className={`${className} ${parent ? styles.Parent : styles.Daycare} ${errorCount ? styles.Error : ''}`}
                value={value}
                placeholder={placeholder}
                disabled={disabled}
                autoFocus={autoFocus}
                required={required}
                onChange={handleChange}
                onBlur={onBlur}
                maxRows={maxRows}
                minRows={minRows}
                maxLength={maxLength}
                minLength={minLength}
                readOnly={readOnly}
            />
            <div className={styles.AdditionalDisplay}>
                {actionText && (
                    <a className={styles.ActionText} onClick={actionText.action}>
                        {t(actionText.label)}
                    </a>
                )}
                {maxCount && (
                    <div className={`${styles.Counter} ${errorCount && styles.ErrorCounter}`}>
                        {count} / {maxCount}
                    </div>
                )}
            </div>
        </div>
    )
}

export default TextArea
